/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-inventory-checkout.reducer';

export const DiagLabInventoryCheckoutDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabInventoryCheckoutEntity = useAppSelector(state => state.diagLabInventoryCheckout.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabInventoryCheckoutDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.detail.title">DiagLabInventoryCheckout</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.id}</dd>
          <dt>
            <span id="brandId">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.brandId">Brand Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.brandId}</dd>
          <dt>
            <span id="batchNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.batchNumber">Batch Number</Translate>
            </span>
            <UncontrolledTooltip target="batchNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.help.batchNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.batchNumber}</dd>
          <dt>
            <span id="serialNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.serialNumber">Serial Number</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.serialNumber}</dd>
          <dt>
            <span id="remainingUses">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.remainingUses">Remaining Uses</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.remainingUses}</dd>
          <dt>
            <span id="avgUsesPerItem">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.avgUsesPerItem">Avg Uses Per Item</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.avgUsesPerItem}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.diagLab ? diagLabInventoryCheckoutEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.type">Type</Translate>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.type ? diagLabInventoryCheckoutEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.inventory">Inventory</Translate>
          </dt>
          <dd>{diagLabInventoryCheckoutEntity.inventory ? diagLabInventoryCheckoutEntity.inventory.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-inventory-checkout" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-inventory-checkout/${diagLabInventoryCheckoutEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabInventoryCheckoutDetail;
